<div class="container-fluid">
  <mat-tab-group>
    <mat-tab label="Configurations">
      <ng-template matTabContent>
        <app-admin-connectors-config></app-admin-connectors-config>
      </ng-template>
    </mat-tab>
    <mat-tab label="Synchronisations">
      <ng-template matTabContent>
        <app-admin-connectors-history></app-admin-connectors-history>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
